<template>
    <v-row no-gutters justify="space-between" class="py-2">
        <v-col cols="auto" class="px-3">
            <p class="mb-0">{{ i18nFormatDateTime(item.TimeStamp) }}</p>
        </v-col>
        <v-col cols="2" class="px-3">
            <UserChip v-if="item.User" :user="item.User" :index="0" :typecolored="true">
            </UserChip>
            <p v-else class="mb-0">{{ item.UserDisplayName }}</p>
        </v-col>
        <v-col v-if="!isJsonChanges" cols="0" class="px-3" style="white-space: pre-line" v-html="item.Text">
        </v-col>
        <v-col v-else cols="0" class="px-3 py-0" style="white-space: pre-line">
            <p v-for="change in jsonChanges" :key="change.PropertyName" class="my-1" v-html="jsonChangesToHtml(change)">
            </p>
        </v-col>
    </v-row>
</template>


<script>
import UserChip from "@/components/Buttons/UserChip.vue";

export default {
    name: 'MachineLogListItem',
    props: {
        item: Object,
    },
    components: {
        UserChip,
    },

    data() {
        return {};
    },

    methods: {
        jsonChangesToHtml(change) {
            if (change.PropertyName) {
                return `<b>${change.PropertyName}</b> changed from <b style="opacity:0.8; font-weight: normal;">${this.typedText(change.PropertyName, change.OriginalValue)}</b> to ${this.typedText(change.PropertyName, change.CurrentValue)}`;
            }
            else {
                var val = "";
                Object.entries(change).forEach(([key, value]) => {
                    val += `<b>${key}</b>: ${value}<br>`;
                });
                return val;
            }
        },

        typedText(property, val) {
            switch (typeof val) {
                case 'string':
                    if (this.isValidDateTimeString(val)) {
                        return `<b style="color: purple; font-weight: normal;">${this.i18nFormatDate(val)}</b>`;
                    }
                    else {
                        var hasBreaklines = /\r|\n/.exec(val);
                        return `${hasBreaklines ? '<br>' : ''}"<b style="color: /*#c3602c*/; font-weight: normal;">${val}</b>"${hasBreaklines ? '<br>' : ''}`;
                    }
                case 'number':
                    return `<b style="color: purple; font-weight: normal;">${val}</b>`;
                case 'boolean':
                    return `<b style="color: ${'var(--v-' + (val ? 'primary' : 'secondary') + '-base)'}; font-weight: normal;">${'' + val}</b>`;
                default:
                    return '""';
            }
        }
    },

    computed: {
        isJsonChanges() {
            return this.item.Text.startsWith("[") && this.item.Text.endsWith("]");
        },

        jsonChanges() {
            //console.log(this.item.Text, JSON.parse(this.item.Text));
            return JSON.parse(this.item.Text);
        },
    },

    watch: {},
};
</script>


<style lang='scss' scoped></style>